import React from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  List,
  ListItem,
  ListItemText
} from '@mui/material';
import {
  Schedule as ScheduleIcon,
  CheckCircle as CheckIcon,
  Cancel as CancelIcon
} from '@mui/icons-material';
import { useTranslation } from '../../hooks/useTranslation';

const daysOrder = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

const BusinessHours = ({ schedule, isMobile = false }) => {
  const { t } = useTranslation();

  const daysOfWeek = {
    monday: t('days.monday'),
    tuesday: t('days.tuesday'),
    wednesday: t('days.wednesday'),
    thursday: t('days.thursday'),
    friday: t('days.friday'),
    saturday: t('days.saturday'),
    sunday: t('days.sunday')
  };

  const daysOfWeekShort = {
    monday: t('days.mondayShort'),
    tuesday: t('days.tuesdayShort'),
    wednesday: t('days.wednesdayShort'),
    thursday: t('days.thursdayShort'),
    friday: t('days.fridayShort'),
    saturday: t('days.saturdayShort'),
    sunday: t('days.sundayShort')
  };
  const formatSchedule = () => {
    if (!schedule) return [];
    
    const dayNames = isMobile ? daysOfWeekShort : daysOfWeek;
    
    return daysOrder.map(day => {
      const hours = schedule[day];
      if (!hours) return null;
      
      return {
        day: dayNames[day],
        hours: hours.closed ? t('salon.closed') : `${hours.open} - ${hours.close}`,
        isOpen: !hours.closed
      };
    }).filter(Boolean);
  };

  if (isMobile) {
    return (
      <Card sx={{ mt: 3, borderRadius: 2, border: '1px solid #E5E7EB' }}>
        <CardContent sx={{ p: 3 }}>
          <Typography variant="h6" sx={{ mb: 2, fontWeight: 600, color: '#000000', display: 'flex', alignItems: 'center', gap: 1 }}>
            <ScheduleIcon />
            {t('salon.openingHours')}
          </Typography>
          
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
            {formatSchedule().map(({ day, hours, isOpen }, index) => (
              <Box key={day} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="body2" sx={{ fontWeight: 500, color: '#000000' }}>
                  {day}
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  {isOpen ? (
                    <CheckIcon sx={{ color: '#16a34a', fontSize: '1rem' }} />
                  ) : (
                    <CancelIcon sx={{ color: '#dc2626', fontSize: '1rem' }} />
                  )}
                  <Typography variant="body2" sx={{ color: '#6B7280' }}>
                    {hours}
                  </Typography>
                </Box>
              </Box>
            ))}
          </Box>
        </CardContent>
      </Card>
    );
  }

  // Desktop version
  return (
    <Card>
      <CardContent>
        <Typography variant="h5" gutterBottom display="flex" alignItems="center" gap={1}>
          <ScheduleIcon />
          {t('salon.openingHours')}
        </Typography>
        
        <List>
          {formatSchedule().map(({ day, hours }, index) => (
            <ListItem key={day} divider={index < formatSchedule().length - 1}>
              <ListItemText
                primary={day}
                secondary={hours}
              />
            </ListItem>
          ))}
        </List>
      </CardContent>
    </Card>
  );
};

export default BusinessHours;